import Cookies from 'js-cookie';
import types from '../types';

const state = {
  size: Cookies.get('size') || 'medium',
  sysConfig: {},
  businessConfig: {}
};

const mutations = {
  [types.SET_SIZE] (state, size) {
    state.size = size;
    Cookies.set('size', size);
  },
  [types.SET_SYS_CONFIG](state, config) {
    state.sysConfig = config;
  },
  [types.SET_BUSINESS_CONFIG](state, config) {
    state.businessConfig = config;
  }
};

const actions = {
  setSize({ commit }, size) {
    commit(types.SET_SIZE, size);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};


// WEBPACK FOOTER //
// ./src/store/modules/setting.js